<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        style="width:20%"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
      
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    /* width: 100px !important;
    min-height: 200px; */
  }
  #app .sidebar-container{
    /* width: 227px !important; */
  }
  .main-container{

  }
</style>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      // routes:[]
    };
  },
  created() {
    console.log(this.routes);
  },
  created() {
    //   this.$store.dispatch("user/GET_ROLES").then(res => {
    //   console.log("123456", JSON.parse(res));
    //   let arrs =  JSON.parse(res)
    //   arrs.map(item=>{
    //       arr.push(item)
    //   })
    //    this.routes = arr
    //    console.log("新数据",  this.routes);
    // });
    // this.routes = arr;
  },
  computed: {
    ...mapGetters(["sidebar", "permission_routers"]),
    routes() {
      // return this.$store.dispatch("user/GET_ROLES")
      // return this.$router.options.routes;
      // console.log('问题',JSON.parse(this.$store.getters.roles))
      let a= this.$store.getters.roles;
      // console.log(111111111111111111111111111111111111111111111111111111111,a)
      if(a.length == 0){
        this.$routes.replace('/login')
      }
      let router = JSON.parse(this.$store.getters.roles)
      return router || []
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
